import type { Dict } from '../types';
import { en } from './en';

export const ml: Dict = en;
